import { render, staticRenderFns } from "./ProfileForReview.vue?vue&type=template&id=31766fe0&scoped=true&"
import script from "./ProfileForReview.vue?vue&type=script&lang=js&"
export * from "./ProfileForReview.vue?vue&type=script&lang=js&"
import style0 from "./ProfileForReview.vue?vue&type=style&index=0&id=31766fe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31766fe0",
  null
  
)

export default component.exports